import React from "react";
import Header from "../components/Header";
import "../components/Home.css";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Request from "../components/Request";
import Form from "../components/Form";
import scroll from "../images/scroll.gif";
import DynamicPage from "../components/meta/DynamicPage";
import Specials from "../components/Specials";
import loanImg from "../images/loan.png";
import seoImg from "../images/seo.png";
import percentImg from "../images/100-percent.png";
import fastImg from "../images/fast.png";

export default function HomePage() {
  const [modal, setModal] = useState(false);
  const FlyInBanner = () => {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
      // Show the banner when the component loads
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 500); // Optional delay before the banner appears
      return () => clearTimeout(timer); // Cleanup timer on unmount
    }, []);

    return (
      <div className="mt-3">
        <div className={`fly-in-banner ${showBanner ? "show" : ""}`}>
          <h3>
            Having an online presence means establishing and maintaining a
            digital identity for your
            <br />
          </h3>
          <br />
          <span className=" alert alert-danger text-secondary">Business</span>
        </div>
      </div>
    );
  };

  const BottomBanner = () => {
    return (
      <>
        <div className=" col-lg-6 col-sm-6 p-3 d-flex justify-content-center mx-auto">
          <ul class="list-group list-group-horizontal-lg">
            <li class="list-group-item text-center">
              <img src={seoImg} width={100} />
              <h3>Optimized</h3>
            </li>
            <li class="list-group-item text-center">
              <img src={loanImg} width={100} />
              <h3>Affordable</h3>
            </li>
            <li class="list-group-item">
              <img src={percentImg} width={100} />
              <h3>Unique</h3>
            </li>
            <li class="list-group-item">
              <img src={fastImg} width={100} /> <h3>Delivery</h3>
            </li>
          </ul>
        </div>
      </>
    );
  };

  function handleModalOpen() {
    setModal(true);
  }
  function handleClose() {
    setModal(false);
  }
  function Home() {
    return (
      <>
        <FlyInBanner />
        <BottomBanner />

        <DynamicPage
          title="Custom Web Development"
          description="Affordable, fast delivery, SEO optomized"
        />

        <div className="container mt-3">
          <div className="text-center"></div>
          <div
            className="tab-content wow fadeIn"
            style={{ visibility: "visible", animationName: "fadeIn" }}
          >
            <div
              role="tabpanel"
              className="tab-pane fade show active"
              id="yearly"
            >
              <div className="row justify-content-center">
                <Specials
                  NewPrice={2000}
                  PackageName="Basic / Small Business Package"
                  Price={2800}
                  special="Save R 800"
                />
                <div className="col-md-6 col-lg-4 mb-30" hidden>
                  <div className="price-item text-center">
                    <div className="price-top mb-3">
                      <h4>Basic / Small Business Package</h4>
                      <span className="text-capitalize">From</span>
                      <h2 className="mb-0">
                        <sup>R</sup>2800
                      </h2>
                    </div>
                    <div className="price-content">
                      <h3>Includes</h3>
                      <ul className="border-bottom mb-30 mt-md-4 pb-3 text-left list-unstyled">
                        <li>
                          <i className="zmdi zmdi-check mr-2"></i>
                          <span className="c-black">Home Page</span>
                        </li>
                        <li>
                          <i className="zmdi zmdi-check mr-2"></i>
                          <span className="c-black">Contact Page</span>
                        </li>
                        <li>
                          <i className="zmdi zmdi-check mr-2"></i>
                          <span className="c-black">About Us</span>
                        </li>
                      </ul>
                      <Link
                        onClick={handleModalOpen}
                        className="btn btn-custom btn btn-outline-info"
                      >
                        <img src={scroll} width={40} /> Request a quote
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-4 mb-30">
                  <div className="price-item text-center">
                    <div className="price-top">
                      <h4>Growth / Advance package</h4>
                      <span className="text-capitalize">From</span>
                      <h2 className="mb-0">
                        <sup>R</sup>5000
                      </h2>
                    </div>
                    <div className="price-content">
                      <h2 className=" text-dark">Includes</h2>
                      <ul className="border-bottom mb-30 mt-md-4 pb-3 text-left list-unstyled">
                        <li>
                          <i className="zmdi zmdi-check mr-2"></i>
                          <span className="c-black">Home Page</span>
                        </li>
                        <li>
                          <i className="zmdi zmdi-check mr-2"></i>
                          <span className="c-black">Contact Page</span>
                        </li>
                        <li>
                          <i className="zmdi zmdi-check mr-2"></i>
                          <span className="c-black">About Page</span>
                        </li>
                        <li>
                          <i className="zmdi zmdi-close mr-2"></i>
                          <span>
                            + 2 Custom Design Pages <br />
                            (choose any additional pages to suit your needs)
                          </span>
                        </li>
                      </ul>
                      <Link
                        onClick={handleModalOpen}
                        className="btn btn-custom btn btn-outline-dark text-dark bg-light"
                      >
                        <img src={scroll} width={40} /> Request a quote
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 mb-30">
                  <div className="price-item text-center">
                    <div className="price-top">
                      <h4>Professional Package</h4>
                      <span className="text-capitalize">From</span>
                      <h2 className="mb-0">
                        <sup>R</sup>8000
                      </h2>
                    </div>
                    <div className="price-content">
                      <h2 className="">Includes</h2>
                      <ul className="border-bottom mb-30 mt-md-4 pb-3 text-left list-unstyled">
                        <li>
                          <i className="zmdi zmdi-check mr-2"></i>
                          <span className="c-black">Home Page</span>
                        </li>
                        <li>
                          <i className="zmdi zmdi-check mr-2"></i>
                          <span className="c-black">Contact Page</span>
                        </li>
                        <li>
                          <i className="zmdi zmdi-check mr-2"></i>
                          <span className="c-black">About Us</span>
                        </li>
                        <li>
                          <i className="zmdi zmdi-close mr-2"></i>
                          <span>Services / Products</span>
                        </li>
                        <li>
                          <i className="zmdi zmdi-close mr-2"></i>
                          <span>Blog/News</span>
                        </li>
                        <li>
                          <i className="zmdi zmdi-close mr-2"></i>
                          <span>Testimonials</span>
                        </li>
                        <li className=" list-unstyled">
                          + 2 Custom Design Pages <br />
                          (any additional pages tailored to your needs)
                        </li>
                      </ul>

                      <Link
                        onClick={handleModalOpen}
                        className="btn btn-custom btn btn-outline-info"
                      >
                        <img src={scroll} width={40} /> Request a quote
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className=" container">
        {modal ? (
          <>
            <Request />
            <button className="btn btn-primary" onClick={handleClose}>
              Back...
            </button>
          </>
        ) : (
          <Home />
        )}
      </div>
    </>
  );
}
